import { useState } from 'react';
import { FolderType } from './redux/types';
export function useAddToGroupFlow() {
    var _a = useState(), selectedGroup = _a[0], setSelectedGroup = _a[1];
    var _b = useState(FolderType.Gallery), selectedSubmissionType = _b[0], setSelectedSubmissionType = _b[1];
    return {
        selectedGroup: selectedGroup,
        selectedSubmissionType: selectedSubmissionType,
        selectGroup: function (group) { return setSelectedGroup(group); },
        resetSelectedGroup: function () { return setSelectedGroup(undefined); },
        selectSubmissionType: function (type) { return setSelectedSubmissionType(type); },
    };
}
//# sourceMappingURL=useAddToGroupFlow.js.map